import React from "react";
import "./style.css";
import Icon from "../Icon";

const stats = [
  { icon: "rocket", value: "50+", label: "Products Shipped", accent: "indigo" },
  { icon: "globe", value: "12+", label: "Countries Served", accent: "blue" },
  { icon: "activity", value: "99.9%", label: "Uptime", accent: "green" },
];

export default function GrowingBusiness() {
  return (
    <section className="growing-section">
      <div className="container">
        <div className="row g-4">
          {/* Left: Content Card */}
          <div className="col-lg-5 col-12">
            <div className="growing-content-card h-100">
              <h2 className="growing-heading">
                An AI-first product company.{" "}
                <span className="growing-heading-accent">
                  Engineered to scale.
                </span>
              </h2>
              <p className="growing-subtext">
                We build AI products end to end — model integration, secure
                architecture, and the infrastructure to run them in production.
                Every system we ship is designed to grow with the business
                behind it.
              </p>
              <div className="growing-location-tag">
                <Icon name="globe" size={16} />
                Remote-first · Working globally
              </div>
              <div className="growing-card-deco" aria-hidden="true">
                AI
              </div>
            </div>
          </div>

          {/* Right: Stats + Vision */}
          <div className="col-lg-7 col-12">
            <div className="row g-4 h-100">
              {/* Stat Cards */}
              {stats.map((stat, index) => (
                <div key={index} className="col-4">
                  <div
                    className={`growing-stat-card growing-stat-card--${stat.accent} icon-hover h-100`}
                  >
                    <div
                      className={`stat-icon-wrap stat-icon-wrap--${stat.accent}`}
                    >
                      <Icon name={stat.icon} size={20} accent={stat.accent} />
                    </div>
                    <span className="growing-stat-value">{stat.value}</span>
                    <span className="growing-stat-label">{stat.label}</span>
                  </div>
                </div>
              ))}

              {/* Vision Card */}
              <div className="col-12">
                <div className="growing-vision-card">
                  <div className="vision-left">
                    <span className="vision-eyebrow">Our Vision</span>
                    <div className="vision-icon">
                      <Icon name="target" size={24} />
                    </div>
                  </div>
                  <div className="vision-right">
                    <p className="vision-quote">
                      "To make production-grade AI accessible to every growing
                      business."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
